<div class="theme_bg">
    <div class="my-2">
        <div class="card-body pb-3">
            <div class="container">
            <div class="row hotel_list1">
                <div class="col-md-12 col-lg-12 nopad mt-0">
                    <app-hotel-detail [hotel]="hotel" [traveller]="traveller"></app-hotel-detail>
                </div>
                <div class="col-md-12 col-lg-12 mt-3 nopad">
                    <app-hotel-detail-images [hotel]="hotel" [traveller]="traveller"></app-hotel-detail-images>
                </div>
               
            </div>
            </div>
        </div>
        <ngx-loading [show]="loading"
            [config]="{primaryColour: primaryColour, secondaryColour: secondaryColour, tertiaryColour: primaryColour, backdropBorderRadius: '3px',fullScreenBackdrop:true}"
            [template]="loadingTemplate"></ngx-loading>
    </div>
    <div class="container">
    <div class="row">
        <div class="col-md-12 col-lg-12 nopad">
            <div class="mb-2 mt-2">
                <div class="pb-3">
                    <app-hotel-room-detail [hotel]="hotel" [traveller]="traveller" id="roomDetail"></app-hotel-room-detail>
                </div>
            </div>
        </div>
        </div>
    </div>
    </div>
    